import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, useTheme } from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined';
import ContentTitleWithIcon from '../../../Simple/ContentTitle/ContentTitleWithIcon';
import { AutomatedOverviewBlock } from '../../../../lib/interfaces/Task';
import { IEntityContentField } from '../../../../lib/interfaces/Common';
import { FIELD_TYPES } from '../../../Form/form.utils';
import './Overview.scss';

type AutomatedOverviewProps = {
	field: IEntityContentField;
};

function scrollToAnchor(event: any) {
	event.preventDefault();
	const targetId = event.target.getAttribute('href').substring(1);
	const targetElement = document.getElementById(targetId);
	if (targetElement) {
		const offset = targetElement.offsetTop - 50;
		window.scrollTo({
			top: offset,
			behavior: 'smooth',
		});
	}
}

const getIcon = (item: AutomatedOverviewBlock) => {
	switch (item.type) {
		case FIELD_TYPES.VIDEO_REF:
			return <SmartDisplayOutlinedIcon />;
		case FIELD_TYPES.CODE_TASK_REF:
			return <TerminalOutlinedIcon />;
		case FIELD_TYPES.QUIZ_REF:
			return <QuizOutlinedIcon />;
		default:
			return null;
	}
};

const AutomatedOverview: FC<AutomatedOverviewProps> = ({ field }) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const overview = field.options.items;

	return overview.length ? (
		<div className="Overview automated-overview">
			<Paper variant="outlined" sx={{ padding: '10px' }} className="wrapper">
				<ContentTitleWithIcon
					content={t('in_this_lesson')}
					id={field.id}
					icon={SummarizeIcon}
				/>
				<ul>
					{overview?.map((item: AutomatedOverviewBlock) => (
						<li key={item.id}>
							<a
								href={`#${item.id}`}
								onClick={(event) => scrollToAnchor(event)}
								style={{ color: theme.typography.body1.color }}
							>
								{item.title} {getIcon(item)}
							</a>
						</li>
					))}
				</ul>
			</Paper>
		</div>
	) : null;
};

export default AutomatedOverview;
